import { FunctionComponent, useState } from 'react';
import { toast } from 'react-toastify';
import { Grid, makeStyles, createStyles, Theme } from '@material-ui/core';
import Document from 'components/Document';
import VisibilityIcon from '@material-ui/icons/Visibility';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import { StyledDropArea } from 'containers/CourtManagerLegalProceedings/ImagineDocuments/style';
import messages from 'containers/CourtManagerLegalProceedings/messages';
import { translate } from 'containers/services/translate';
import { CORPO_IMAGINE_CODE } from 'containers/CourtManagerLegalProceedings/ImagineDocuments/constant';
import { IntlShape, injectIntl } from 'react-intl';
import { get, isEmpty } from 'lodash';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    dropZone: {
      minHeight: '180px',
    },
    upload: {
      backgroundColor: '#f5f5f5',
      boxShadow: 'none',
      borderBottom: '1px solid rgba(0, 25, 77, 0.08)',
      borderRadius: '10px',
      padding: '16px',
      alignItems: 'center',
    },
  }),
);
export interface DropZoneFileProps {
  intl: IntlShape;
  requestUploadDocumentManager?: Function;
  claimNumber?: string;
  docTypeId?: any;
  docTypeName?: any;
  setOpenUploadFileArea: Function;
}
const DropZoneFile: FunctionComponent<DropZoneFileProps> = ({
  ...props
}): JSX.Element => {
  const [file, setFile] = useState([]);

  const handleChange = (files: any) => {
    setFile(files[0]);
  };

  const classes = useStyles();

  const handleClick = () => {
    if (props.requestUploadDocumentManager) {
      const payload = {
        documents: [
          {
            DocType: props.docTypeName,
            FileName: `${props.docTypeName.trim()}.pdf`,
            Content: get(get(file, 'data').split('base64,'), '[1]'),
          },
        ],
        claimExtCode: get(props, ['claimNumber']),
        channelCode: CORPO_IMAGINE_CODE,
      };
      props.requestUploadDocumentManager(payload, handleSuccess);
    }
  };
  const handleSuccess = () => {
    toast.success('Le document a été téléchargé avec succès');
    setFile([]);
    props.setOpenUploadFileArea(false);
  };
  const openPdfInNewWindow = (base64PdfData: any) => {
    const dataUri = `${base64PdfData}`;
    window.open(dataUri, '_blank');
  };

  return (
    <>
      <Grid container direction="row" spacing={2} alignItems="center">
        <Grid item xs={8}>
          {isEmpty(file) ? (
            <StyledDropArea
              onAdd={handleChange}
              acceptedFiles={['application/pdf']} // Accept only PDF files
              filesLimit={1} // Optional: Limit to one file
              showPreviewsInDropzone={false}
              showPreviews={false}
              showAlerts={true}
              dropzoneClass={classes.dropZone}
              fileObjects={file}
              dropzoneText={translate(
                { ...messages.uploadDocumentTitle },
                props,
              )}
              previewGridProps={{
                container: {
                  spacing: 2,
                  direction: 'row',
                },
                item: {
                  xs: 12,
                },
              }}
            />
          ) : (
            <Document
              name={props.docTypeName}
              type={props.docTypeName}
              icon={
                <VisibilityIcon
                  style={{ color: 'black' }}
                  className="consult"
                  onClick={() => openPdfInNewWindow(get(file, 'data'))}
                />
              }
            />
          )}
        </Grid>
        <Grid xs>
          <PrimaryButton
            background={'#0075C9'}
            titlecolor={'#FFFFFF'}
            border={'#0075C9'}
            title={'télécharger'}
            onClick={handleClick}
            disabled={isEmpty(file)}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default injectIntl(DropZoneFile);
